"use client";

import useUtility from "@/app/_hooks/useUtility";
import { useSection } from "./_hooks/useSection";
import Link from "next/link";
import { frontendImage } from "@/lib/helpers";
import Image from "next/image";
import WalletBannerSkeleton from "./_skeletons/WalletBannerSkeleton";

export const WalletBannerSection = () => {
    const { trans } = useUtility();
    const { content, loading } = useSection("wallet_banner");

    if (loading) return <WalletBannerSkeleton />;

    return (
        <section className="wallet-section section-bg">
            <div className="container wallet-container">
                <div className="row justify-content-center">
                    {/* Text Column */}
                    <div className="col-lg-6 col-md-7">
                        <div className="wallet-content">
                            <h3 className="wallet-content__title gradient-text">
                                {trans(content?.title)}
                                <span className="wallet-content__title-shape">
                                    <Image src={frontendImage(content?.shape_image, "wallet_banner")} width={312} height={17} alt={trans("Shape image")} />
                                </span>
                            </h3>
                            <p className="wallet-content__desc">{trans(content?.description)}</p>
                            <Link href={content?.button_link || "#"} className="btn btn--base">
                                {trans(content?.button_text)}
                            </Link>
                        </div>
                    </div>

                    {/* Image Column */}
                    <div className="col-lg-6 col-md-5 col-sm-9">
                        <div className="wallet-thumb">
                            <Image src={frontendImage(content?.wallet_image, "wallet_banner")} alt={trans("Wallet image")} width={669} height={379} />
                        </div>
                    </div>
                </div>

                {/* Subtitle Row */}
                <div className="row">
                    <div className="col-lg-7 col-md-9">
                        <div className="wallet-content two">
                            <h3 className="wallet-content__title gradient-text">{trans(content?.subtitle)}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
